import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";

const PoseService = {};

PoseService.getPoses = function (params) {
  return fetch({
    url: ApiConstant.POSE_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
PoseService.downalodPosesExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.POSE_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids }
  });
};
PoseService.getSinglePose = function (params) {
  return fetch({
    url: ApiConstant.POSE_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
PoseService.getLatestPoseName = function (params) {
  return fetch({
    url: ApiConstant.POSE_LATEST_NAME,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
PoseService.addPose = function (data, params) {
  
  return fetch({
    url: ApiConstant.POSE_CREATE,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
PoseService.editPose = function (data, params) {
  return fetch({
    url: ApiConstant.POSE_UPDATE,
    method: "PUT", 
    data: data,
    params: Utils.filterHeaderParams(params),
  });
};
PoseService.editPoseStatus = function (data, status) {
  const payload = {
    status: status,
    poses_ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.POSE_UPDATE_STATUS,
    method: "PUT",
    data: payload,
  });
};

export default PoseService;
